/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './physio-category.reducer';

export const PhysioCategoryDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const physioCategoryEntity = useAppSelector(state => state.physioCategory.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="physioCategoryDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.physioCategory.detail.title">PhysioCategory</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.physioCategory.id">Id</Translate>
            </span>
          </dt>
          <dd>{physioCategoryEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.physioCategory.active">Active</Translate>
            </span>
          </dt>
          <dd>{physioCategoryEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.physioCategory.description">Description</Translate>
            </span>
          </dt>
          <dd>{physioCategoryEntity.description}</dd>
          <dt>
            <span id="displayKey">
              <Translate contentKey="tinyMedicRestApp.physioCategory.displayKey">Display Key</Translate>
            </span>
          </dt>
          <dd>{physioCategoryEntity.displayKey}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.physioCategory.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{physioCategoryEntity.lastupdated}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.physioCategory.name">Name</Translate>
            </span>
          </dt>
          <dd>{physioCategoryEntity.name}</dd>
          <dt>
            <span id="tmSample">
              <Translate contentKey="tinyMedicRestApp.physioCategory.tmSample">Tm Sample</Translate>
            </span>
          </dt>
          <dd>{physioCategoryEntity.tmSample}</dd>
          <dt>
            <span id="sortOrder">
              <Translate contentKey="tinyMedicRestApp.physioCategory.sortOrder">Sort Order</Translate>
            </span>
          </dt>
          <dd>{physioCategoryEntity.sortOrder}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.physioCategory.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{physioCategoryEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.physioCategory.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{physioCategoryEntity.microSec}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.physioCategory.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{physioCategoryEntity.cursor}</dd>
          <dt>
            <span id="charge">
              <Translate contentKey="tinyMedicRestApp.physioCategory.charge">Charge</Translate>
            </span>
          </dt>
          <dd>{physioCategoryEntity.charge}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.physioCategory.hospital">Hospital</Translate>
          </dt>
          <dd>{physioCategoryEntity.hospital ? physioCategoryEntity.hospital.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/physio-category" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/physio-category/${physioCategoryEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PhysioCategoryDetail;
